import customAxios from "../index";
import qs from "qs";

export const createService = (data: any) => {
  return customAxios({
    method: "POST",
    url: "/services/create",
    data,
  });
};

export const createNewServiceCategory = (data: any) => {
  return customAxios({
    method: "POST",
    url: "/service-categories/create",
    data,
  });
};


export const getServices = (params: any,id?:number) => {
  return customAxios({
    method: "GET",
    url: `/services/${id? id : ""}`,
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
} 

export const getCategories = (params: any) => {
  return customAxios({
    method: "GET",
    url: `/service-categories/all`,
    params,
  });
};

export const updateService = (id: number, data: any) => {
  return customAxios({
    method: "PUT",
    url: `/services/update/${id}`,
    data,
  });
} 

export const deleteService = (id: number) => {
  return customAxios({
    method: "DELETE",
    url: `/services/${id}`,
  });
}

export const getServiceNameSuggestions = (text: string) => {
  return customAxios({
    method: "GET",
    url: "/services/auto-suggestions/name/",
    params: { text },
  });
};

export const getServiceCodeSuggestions = (text: string) => {
  return customAxios({
    method: "GET",
    url: "/services/auto-suggestions/code/",
    params: { text },
  });
};

export const createServiceCategory = (formData: FormData) => {
  return customAxios({
    method: "POST",
    url: "/service-categories/create",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


